import React from "react";

const AZAVAmpel = ({ status }) => {
  const colors = {
    gruen: "bg-emerald-500",
    gelb: "bg-amber-500",
    rot: "bg-red-500"
  };
  const labels = {
    gruen: "Vollständig",
    gelb: "Frist läuft ab",
    rot: "Pflicht fehlt"
  };
  
  if (!status) return null;
  
  return (
    <div className="flex items-center gap-2" data-testid={`azav-ampel-${status}`}>
      <div className={`w-3 h-3 rounded-full ${colors[status] || 'bg-gray-400'}`}></div>
      <span className="text-xs text-[#78716c]">{labels[status] || status}</span>
    </div>
  );
};

export default AZAVAmpel;
